@use 'Variables' as *;

%dimmer-overlay {
  background: $dimmer;
  pointer-events: auto;
  cursor: wait;

  .MuiCircularProgress-root {
    position: absolute;
    inset: 0;
    margin: auto;
  }
}

.dimmer-content {
  position: relative;

  .dimmer-active {
    @extend %dimmer-overlay;
    height: 100%;
    position: absolute;
    width: 100%;
    z-index: 10;
  }
}

.dimmer-active--layout {
  @extend %dimmer-overlay;
  position: fixed;
  top: var(--appbar-height, 64px);
  left: var(--content-left, 0px);
  right: 0;
  bottom: 0;
  z-index: 1090;
}
